import { Component } from '@angular/core';

@Component({
  selector: 'hbo-order-actions',
  templateUrl: './order-actions.component.html',
  styleUrls: ['./order-actions.component.scss']
})
export class OrderActionsComponent {

}
